import { render } from "./AppHeader.vue?vue&type=template&id=16bd58b1&ts=true"
import script from "./AppHeader.vue?vue&type=script&lang=ts"
export * from "./AppHeader.vue?vue&type=script&lang=ts"

import "./AppHeader.vue?vue&type=style&index=0&id=16bd58b1&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__